'use strict';
require('../categories/CompanyCategoryService.js');

function CompanySettingNoticeCategoriesCtrl(
  $scope,
  categories,
  priorities,
  translations,
  $stateParams,
  $state,
  $q,
  CompanyCategoryService,
  growl
) {
  var origCategories = [];

  $scope.categories = categories;
  $scope.translations = translations;
  $scope.priorities = priorities;

  // Save each category object to a new array for comparison later
  $scope.categories.$promise.then(function() {
    for(var i = 0; i < $scope.categories.length; i++) {
      origCategories.push(angular.copy($scope.categories[i]));
    }
  });

  function saveCategory(category) {
    if( ! category.id) {
      return category.$save({companyId: $stateParams.companyId}, function(category, headers) {
        category.id = headers("location").split("/").pop();

        growl.addSuccessMessage(translations['settings.create-category-success'] + ': ' + category.name);

        return category;
      });
    }

    for(var i = 0; i < origCategories.length; i++) {
      if(origCategories[i].id === category.id) {
        if(angular.equals(origCategories[i], category)) {
          return $scope.createQ(function(resolve) {
            resolve(category);
          });
        }
        else {
          return category.$update({companyId: $stateParams.companyId});
        }
      }
    }

    return category.$update({companyId: $stateParams.companyId});
  }

  $scope.saveCategories = function() {
    return $q.all($scope.categories.map(saveCategory)).then(function(categories) {
      $scope.categories = categories;

      origCategories = angular.copy($scope.categories);

      $state.reload();

      $scope.$emit('categoriesChanged', angular.copy($scope.categories));
    }, function() {
      growl.addErrorMessage(translations['settings.create-category-failure']);
    });
  };

  $scope.addCategory = function() {
    $scope.categories.push(new CompanyCategoryService({
      name: '',
      color: 4279856278, // #196c96
      favourite: false,
      type: 'REMINDER_CATEGORY'
    }));

    $scope.lastItem = $scope.categories.length - 1;
  };

  $scope.deleteCategory = function(category) {
    category.$delete({companyId: $stateParams.companyId, categoryId: category.id}, function() {
      function categoryFilter(c) {
        return c.id !== category.id;
      }

      $scope.categories = $scope.categories.filter(categoryFilter);
      origCategories    = $scope.categories.filter(categoryFilter);

      growl.addSuccessMessage(translations['settings.remove-category-success']);
      $scope.$emit('categoriesChanged', angular.copy($scope.categories));
    },
    function(response) {
      if (response.status === 403 && response.data.error.code === 3007) {
        growl.addErrorMessage(translations['settings.remove-category-failure-3007']);
      } else {
        growl.addErrorMessage(translations['settings.remove-category-failure']);
      }
    });
  };

  $scope.searchStatuses = function(filter){
    $scope.priorities = priorities.filter(function(p){
      return p.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
    });
  }

  $scope.checkAllCategories = function(selectedAll, index){
    $scope.categories[index].priorities = [];
    if(selectedAll){
      priorities.forEach(function(p) {
        $scope.categories[index].priorities.push(p);
      });
    }
  };

  $scope.checkedCategory = function(category, priority){
    var indexCategory = $scope.categories.findIndex(function(c){
                          return c.id === category.id;
                        });
    if(indexCategory > -1 && $scope.categories[indexCategory].priorities){
      return $scope.categories[indexCategory].priorities.findIndex(function(p){
              return p.id === priority.id;
            });
    }else{
      return -1;
    }
  };
}

CompanySettingNoticeCategoriesCtrl.resolve = {
  categories: ['$stateParams', 'CompanyCategoryService', function($stateParams, CompanyCategoryService) {
    return CompanyCategoryService.query({companyId: $stateParams.companyId, limit: 100, type: 'REMINDER_CATEGORY'}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'settings.create-category-success',
      'settings.create-category-failure',
      'settings.remove-category-success',
      'settings.remove-category-failure',
      'settings.remove-category-failure-3007'
    ]);
  }]
};
module.exports = CompanySettingNoticeCategoriesCtrl;

angular.module('dokiv')
  .controller('CompanySettingNoticeCategoriesCtrl', [
  '$scope',
  'categories',
  'priorities',
  'translations',
  '$stateParams',
  '$state',
  '$q',
  'CompanyCategoryService',
  'growl',
  CompanySettingNoticeCategoriesCtrl
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/settings/CompanySettingNoticeCategoriesCtrl.js
// module id = 411
// module chunks = 0